import RevisionPeriodSelect from 'components/inputs/revision-period-select/RevisionPeriodSelect';
import { IFormInputSpecPeriod } from 'pages/revisions-module/template-editor/editors/form/types';

/**
 * Preview for a date input.
 */
export default function PeriodInputPreview({ spec }: { spec: IFormInputSpecPeriod }) {
  return <RevisionPeriodSelect required={spec.required} readOnly={spec.readOnly} size="sm" />;
}
